// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"ef13e617","769":"3f0a0c52"}[chunkId] + ".chunk.js";
};